export default {
    'language': '罗马尼亚语',
}
;
